








































import { computed, defineComponent, ref } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import useUserDelete from "@/hooks/useUserDelete";
import { $t } from "@/lib/i18nHelpers";
import { formatTimeInterval } from "@/lib/time";
import { FormFields, FormValues } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseForm from "@/components/BaseForm";
import BasePage from "@/components/BasePage";
import PageTitle from "@/components/PageTitle";

export default defineComponent({
  name: "DeleteAccountView",
  components: { BaseForm, PageTitle, BaseButton, BaseConfirm, BasePage },
  props: {
    loading: { value: Boolean, default: false },
  },
  setup(_, { emit }) {
    const { isCreator } = useAuthUser();
    const { restoreDate, restoreInterval } = useUserDelete();
    const showConfirm = ref(false);
    const values = ref<FormValues>({ password: "" });
    const validate = ref<() => Promise<void>>(async () => {});
    const isValid = ref(false);

    const fields = computed<FormFields>(() => {
      return [
        {
          name: "password",
          type: "password",
          label: $t("Password"),
          rules: ["required"],
          validationMode: "aggressive",
        },
      ];
    });

    const onDeleteClick = () => {
      emit("delete", { password: values.value.password }, () => {
        showConfirm.value = false;
      });
    };
    const handleShowDelete = () => {
      validate.value();
      if (isValid.value) {
        showConfirm.value = true;
      }
    };
    return {
      validate,
      fields,
      values,
      isValid,
      isCreator,
      showConfirm,
      restoreDate,
      restoreInterval,
      onDeleteClick,
      handleShowDelete,
      formatTimeInterval,
    };
  },
});
